import Api from "../../../../../Services/Api";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";

export const dummyDataInventoryHadiah = [
  {
    id: 1,
    kodeHadiah: "HCK",
    giftName: "Scoopy Sporty Chrome",
    category: "BK",
    locator: "Storing Lt.2 A1",
    jumlah: 4,
  },
];

export const initialFilterDataHadiah = {
  id: null,
  giftCode: null,
  giftName: null,
  giftCategory: null,
  kodeLocator: null,
  giftBarcode: null,
};

export const initialDataHadiah = {
  id: null,
  giftCode: null,
  giftName: null,
  giftCategory: null,
  kodeLocator: null,
  jumlah: null,
};

export const initialSearchHadiah = {
  giftName: null,
};

export const tableConfigHadiah = [
  {
    name: "giftCode",
    label: "Kode Hadiah",
    options: {
      sort: true,
    },
  },
  {
    name: "giftName",
    label: "Nama Hadiah",
    options: {
      sort: false,
    },
  },
  {
    name: "giftCategory",
    label: "Kategori",
    options: {
      sort: false,
    },
  },
  {
    name: "locator",
    label: "Locator",
    options: {
      sort: false,
    },
  },
  {
    name: "qty",
    label: "Jumlah",
    options: {
      sort: false,
    },
  },
];

export const pageConfigHadiah = {
  home: {
    pageTitle: "Hadiah",
    tableConfig: tableConfigHadiah,
    searchGrid: { name: "giftName", label: "Nama Hadiah" },
  },
  filter: [
    {
      type: "SimpleDDL",
      box: "search",
      name: "giftCode",
      label: "Kode Hadiah",
    },
    {
      type: "SimpleInput",
      name: "giftName",
      label: "Nama Hadiah",
      readOnly: true,
    },
    {
      type: "SimpleDDL",
      box: "search",
      name: "giftCategory",
      label: "Kategori",
    },
    {
      type: "SimpleDDL",
      id: "select_options_filter_lcoator",
      box: "search",
      name: "kodeLocator",
      label: "Locator",
    },
    {
      type: "SimpleInput",
      id: "input_text_qr_code",
      name: "giftBarcode",
      label: "QR Code",
    },
  ],
  detail: {
    pageTitle: "Detail Inventory Hadiah",
    tableConfig: [
      {
        name: "qrCode",
        label: "QR Code",
        options: {
          sort: true,
        },
      },
    ],
    firstGrid: [
      { name: "giftCode", label: "Kode Hadiah" },
      { name: "giftName", label: "Nama Hadiah" },
    ],
    secondGrid: [
      { name: "giftCategory", label: "Kategori" },
      { name: "locator", label: "Locator" },
    ],
    detailHistory: {
      pageTitle: "Riwayat Mutasi Hadiah",
      firstGrid: [
        { name: "giftCode", label: "Kode Hadiah" },
        { name: "giftName", label: "Nama Hadiah" },
      ],
    },
  },
  stock: {
    pageTitle: "Kartu Stock Hadiah",
    firstGrid: [
      { name: "giftCode", label: "Kode Hadiah" },
      { name: "giftName", label: "Nama Hadiah" },
    ],
    secondGrid: [
      { name: "giftCategory", label: "Kategori" },
      { name: "locator", label: "Locator" },
    ],
    stockInfo: {
      pageTitle: "Detail Stock Info (Dengan QR)",
    },
  },
};

const constructInventoryHadiahBody = (body) => ({
  kodeCabang: body?.paramFilters?.kodeCabang ?? [],
  kodeLocator: body?.paramFilters?.kodeLocator ?? null,
  giftCode: body?.paramFilters?.giftCode ?? null,
  giftName: body?.paramFilters?.giftName ?? null,
  giftBarcode: body?.paramFilters?.giftBarcode ?? null,
  giftCategory: body?.paramFilters?.giftCategory ?? null,
  limit: body?.limit ?? 5,
  page: body?.page ?? 1,
});

export const fetchDataInventoryHadiah = async (setState, body, setError) => {
  const requestBody = constructInventoryHadiahBody(body);

  try {
    const response = await Api.create(
      "NAGAMAS_TRANSACTION"
    ).getAllInventoryGiftByParam(requestBody);

    setState((prevState) => ({
      ...prevState,
      dataTable: response.data.data,
      pagination: {
        ...prevState.pagination,
        count: response.data.totalData,
      },
    }));
  } catch (err) {
    console.error(err);
    setError && setError(err);
  }
};

export const fetchDataMasterGift = async (setState) => {
  try {
    let response = await Api.create("NAGAMAS_MASTER_DATA").getAllHadiah();
    if (response.ok) {
      setState((prevState) => ({
        ...prevState,
        dataGiftDDL: response.data.data,
      }));
    }
  } catch (error) {
    console.log("errors: ", error);
  }
};

export const fetchDataDetailInventoryGift = async (
  setState,
  body,
  setError
) => {
  let requestBody = null;
  if (body && Object.keys(body).length > 0) {
    requestBody = {
      giftCode: body.giftCode,
      kodeLocator: body.kodeLocator,
      kodeCabang: [body.kodeCabang],
    };
  }

  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailInventoryGift,
    menuName: "Detail Inventory Gift",
    setError,
    args:
      requestBody && Object.keys(requestBody).length > 0
        ? requestBody
        : {
            paramFilters: {},
            page: 1,
            limit: 5,
          },
  });

  if (response.ok && response.data.status === HttpStatus.SUCCESS) {
    const mapped = response.data.data.map((item) => ({
      qrCode: item,
    }));
    setState((prevState) => ({
      ...prevState,
      dataTable: mapped,
      rawDataTable: mapped,
      pagination:{
          ...prevState.pagination,
          count: response.data.data.length
      }
    }));
  }
};

export const fetchDataDetailHistoryInventoryGift = async (
  setState,
  body,
  setError
) => {
  let requestBody = null;
  if (body && Object.keys(body).length > 0) {
    requestBody = {
      giftBarcode: body.qrCode,
    };
  }

  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailHistoryInventoryGift,
    menuName: "Detail History Inventory Gift",
    setError,
    args: contructQueryParam(requestBody),
  });

  if (response.ok && response.data.status === HttpStatus.SUCCESS) {
    setState((prevState) => ({
      ...prevState,
      dataTable: response.data.data,
      pagination:{
          ...prevState.pagination,
          count: response.data.data.length
      }
    }));
  }
};

export const fetchCardStockGift = async (
  setState,
  body,
  setError,
  selectedData
) => {
  const fixedBody = {
    startDate: body.startDate,
    endDate: body.endDate,
    giftCode: selectedData.giftCode,
    kodeLocator: selectedData.kodeLocator,
    qr: selectedData.qr,
    kodeCabang: body.kodeCabang,
  };

  let res = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getGiftStockCard,
    menuName: "Kartu Stock Gift",
    setError,
    args: fixedBody,
  });

  if (res.ok && res.data.status === HttpStatus.SUCCESS) {
    setState((prevState) => ({
      ...prevState,
      dataTable: res.data.data,
      pagination:{
          ...prevState.pagination,
          count: res.data.data.length
      }
    }));
  }
};

export const fetchCardStockDetailGift = async (setState, body, setError, selectedParentData ) => {
  const requestBody = {
    date: body.stockDate, 
    giftCode: selectedParentData.giftCode,
    kodeCabang: body.kodeCabang,
    kodeLocator: body.kodeLocator,
    transactionType: body.transactionType,
  };

  const apiFunction = selectedParentData.qr
    ? Api.create("NAGAMAS_TRANSACTION").getGiftStockCardDetailQR
    : Api.create("NAGAMAS_TRANSACTION").getGiftStockCardDetailNonQR;

  const menuName = selectedParentData.qr
    ? "Kartu Stock Gift Dengan QR"
    : "Kartu Stock Gift Tanpa QR";

  let res = await fetchDataAsync({
    asyncFn: apiFunction,
    menuName,
    setError,
    args: requestBody,
  });
  console.log(res);

  if (res.ok && res.data.status === HttpStatus.SUCCESS) {
    setState((prevState) => ({
      ...prevState,
      dataTable: res.data.data,
      pagination:{
          ...prevState.pagination,
          count: res.data.data.length
      }
    }));
  }
};
